var __jsx = React.createElement;
import React from 'react';
import Card from 'react-bootstrap/Card';
import styles from '../styles/elements/FloatMessage.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

var FloatMessage = function FloatMessage(props) {
  var message = props.message;
  return __jsx("div", {
    className: styles.back
  }, __jsx("section", {
    className: styles.root
  }, __jsx(Card, {
    className: "w-100 px-md-5 py-md-3 p-0"
  }, __jsx(Card.Body, null, __jsx(Card.Title, null, __jsx(FontAwesomeIcon, {
    icon: faExclamationCircle,
    className: "mr-2",
    height: "16",
    width: "16"
  }), message)))));
};

export default FloatMessage;